/**
 * PricingSection — the pricing block, rendered in TWO places from ONE definition: in-page at
 * `#pricing` on the landing page, and as the `/pricing` route.
 *
 * 🔴 THE PRICES ARE DOWN (D-217.3, ruled s217). Reade: *"Let's reset the pricing. I want to
 * finish the functionality before determining pricing."* — and, of the live page, *"yes take it
 * down."* Until `PRICING-RESET-1` lands, the public site states **no price anywhere a visitor or
 * a search engine can read one**: no tier cards, no amounts, no renewal fee, and no `Offer` in
 * the structured data (`StructuredData.tsx` no longer imports from this file).
 *
 * 🔴 The PAGE STAYS. `/pricing` is still a real route and still in the sitemap — people search
 * "X pricing" and partners need a URL to send. A route that 404s after being indexed is a worse
 * outcome than a route that answers honestly that the number is not set yet. What came down is
 * the number, not the page.
 *
 * 🔴 `PRICING_TIERS` and the `PricingTier` type are GONE, not commented out. They were read by
 * `StructuredData` for the `Offer` graphs, so leaving them would have left a live path from a
 * stale array to Google. The tier CONTENT (the feature bullets) is recoverable from git at
 * `accce81b` when the reset writes the new numbers; keeping a dead array in the tree so it is
 * convenient to un-delete is how a retired price quietly ships again.
 *
 * The section keeps its shape, its background and its trial call-to-action so the page does not
 * develop a hole where the cards were.
 */
import { SAGE, WARM, FONT } from '@shared/brand';
import { CONTAINER } from './PublicLayout';

export function PricingSection({
  onStart,
  heading = 'h2',
}: {
  onStart: () => void;
  heading?: 'h1' | 'h2';
}) {
  const Heading = heading;
  return (
    <section id="pricing" style={{ background: WARM.cream, padding: '96px 32px 90px' }}>
      <div className={CONTAINER}>
        <div style={{ textAlign: 'center', maxWidth: 620, margin: '0 auto' }}>
          <div style={{ fontSize: 13, fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', color: SAGE[400], marginBottom: 16 }}>
            Pricing
          </div>
          <Heading style={{ fontFamily: FONT.serif, fontWeight: 400, fontSize: 40, lineHeight: 1.14, letterSpacing: '-0.01em', color: WARM.ink, margin: '0 0 16px' }}>
            Pricing is announced at launch.
          </Heading>
          <p style={{ fontSize: 17, lineHeight: 1.6, color: '#514D44', margin: 0 }}>
            Start with the free trial — no credit card.
          </p>
          <button
            onClick={onStart}
            style={{
              display: 'inline-block',
              marginTop: 32,
              fontSize: 15.5,
              color: WARM.white,
              background: SAGE[600],
              padding: '13px 30px',
              borderRadius: 8,
              fontWeight: 500,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Start free trial
          </button>
        </div>
      </div>
    </section>
  );
}
